//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Shared/Button'
import Card from '@/components/Register/components/Card.vue'
import FinishedProject from '@/components/Register/components/FinishedProject.vue'
import { FormInput } from '@/components/Form'
import { rutFilter } from 'vue-dni'

export default {
  name: 'ValidateRut',
  middleware: ['user-validate'],
  components: { Card, Button, FormInput, FinishedProject },
  props: {
    phase: {
      type: String,
      default: '0',
    },
    setValue: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        identification_number: '',
        id: null,
        names: '',
        lastnames: '',
        error: false,
      },
      loading: false,
      showFinishedProject: false,
    }
  },
  watch: {
    form: {
      handler() {
        this.form.identification_number = rutFilter(
          this.form.identification_number
        )
      },
      deep: true,
    },
  },
  methods: {
    async submit() {
      this.loading = true
      const { code } = this.$route.params
      if (!code) {
        this.$buefy.notification.open({
          message: 'El código de invitación es inválido',
          type: 'is-danger',
          hasIcon: true,
          duration: 7000,
        })
        this.loading = false
        return
      }
      try {
        const {
          user,
          errorMessage,
        } = await this.$repository.user.getByIdNumberAndProjectCode({
          identificationNumber: this.form.identification_number,
          code,
        })
        if (!user && errorMessage === 'USER_NOT_FOUND') {
          this.form.error = true
          this.$emit('setValue', this.form, true)
        }

        if (!user && errorMessage === 'PROJECT_FINISHED') {
          this.showFinishedProject = true
        }

        if (user && user.id) {
          this.form = {
            ...this.form,
            id: user.id,
            names: user.names,
            lastnames: user.lastnames,
            register_token: user.register_token,
            email: user?.email || '',
            phone: user?.phone || '',
          }
          this.$emit('setValue', this.form)
        }
      } catch (e) {
        this.$buefy.notification.open({
          message: e.message,
          type: 'is-danger',
          hasIcon: true,
          duration: 7000,
        })
      } finally {
        this.loading = false
      }
    },
  },
}
